import clsx from "clsx";
import React from "react";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import { TextInput } from "../criteria/TextInput";

interface SearchNameInputProps {
	error?: string;
	onChange: React.ReactEventHandler<HTMLInputElement>;
}

export function SearchNameInput({ error, onChange }: SearchNameInputProps) {
	const { isMobile } = useAccessWindowSize();

	return (
		<div className={clsx("form-group", { error })}>
			<TextInput
				id="search-name"
				name="search"
				placeholder="Enter search name"
				label="Search name"
				error={error}
				autoFocus={!isMobile}
				onChange={onChange}
			/>
		</div>
	);
}
